import { Image } from '@mantine/core';

interface IPreviewImageProps {
    src: any;
}
export const PreviewImage = (props: IPreviewImageProps) => {
    return <Image width={132.28} height={170.08} className={' border-2'} fit="cover" src={props.src} alt="Image preview" />;
};
